var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon-clipboard',{staticClass:"cursor-copy",attrs:{"title":"Kopieer adres naar klembord"},on:{"click":_vm.copyAddressToClipboard}})
}
var staticRenderFns = []

export { render, staticRenderFns }